import React, { ComponentClass } from 'react';
import { Route, Redirect } from 'react-router-dom';
import useRouter from 'use-react-router';
import { useSelector } from 'react-redux';
import * as routes from '../../../../../../../common/constants/routes';
import {
  twillioNumberSelector,
  hasDeactivatedNumberSelector,
} from '@mm/state/selectors/twillio';

import { SMS_SECTIONS, SMS_SECTIONS_ACTIVE } from './smsRouting';

export const SMSRoute = ({
  path,
  chatbotId,
  component: Component,
}: {
  path: string;
  chatbotId: number;
  component?: ComponentClass;
}) => {
  const twilioNumber = useSelector(twillioNumberSelector);
  const hasDiactivatedNumber = useSelector(hasDeactivatedNumberSelector);
  const { location } = useRouter();

  const allowAreaCodeRedirect = (location?.state as { allowRedirect?: boolean })
    ?.allowRedirect;
  return (
    <Route
      path={path}
      exact
      render={() => {
        if (twilioNumber && !hasDiactivatedNumber && !allowAreaCodeRedirect) {
          return (
            <Redirect
              to={{
                pathname: routes.SETTINGS_SMS_VIEW_NUMBER_PATH(chatbotId),
                state: { ...location.state, allowRedirect: true },
              }}
            />
          );
        }
        if (!twilioNumber && !allowAreaCodeRedirect) {
          return (
            <Redirect
              to={{
                pathname: routes.SETTINGS_SMS_ACTIVATE_PATH(chatbotId),
                state: location.state,
              }}
            />
          );
        }

        return Component && <Component />;
      }}
    />
  );
};

export const SMSRouter = ({
  chatbotId,
  path,
}: {
  chatbotId: number;
  path: string;
}) => {
  const twilioNumber = useSelector(twillioNumberSelector);
  return (
    <>
      <SMSRoute path={path} chatbotId={chatbotId} />
      {SMS_SECTIONS.map(section => (
        <SMSRoute
          chatbotId={chatbotId}
          key={section.id}
          path={section.path(chatbotId)}
          component={section.component as ComponentClass<any, any>}
        />
      ))}
      <Route
        component={SMS_SECTIONS_ACTIVE.component}
        path={SMS_SECTIONS_ACTIVE.path(chatbotId)}
      >
        {twilioNumber && <Redirect to={path} />}
      </Route>
    </>
  );
};
